const messages = {
  en: {
    translations: {
      signup: {
        title: "Sign up",
        toasts: {
          success: "User created successfully! Please login!",
          fail: "Error creating user. Check the reported data.",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Enter",
          register: "Don't have an account? Register!",
        },
      },
      auth: {
        toasts: {
          success: "Login successfully!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets today: ",
          },
        },
        metrics: {
          filterDate: "Filter by day",
          sales: {
            title: "Sales",
            subtitle: "{{count}} purchase(s) sent to pixel",
          },
          clicks: {
            title: "Link clicks",
            subtitle: "Counter accesses on selected day",
          },
          conversations: {
            title: "Conversations started",
            subtitle: "Contacts matched in Whaticket on selected day",
          },
        },
        messages: {
          inAttendance: {
            title: "In Service"
          },
          waiting: {
            title: "Waiting"
          },
          closed: {
            title: "Closed"
          }
        }
      },
      connections: {
        title: "Connections",
        toasts: {
          deleted: "WhatsApp connection deleted sucessfully!",
          whatsappIdCopied: "WhatsApp ID copied! Paste into MacroDroid (whatsappId field).",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? It cannot be reverted.",
          disconnectTitle: "Disconnect",
          disconnectMessage: "Are you sure? You'll need to read QR Code again.",
        },
        buttons: {
          add: "Add WhatsApp",
          disconnect: "Disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          connecting: "Connectiing",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content:
              "Make sure your cell phone is connected to the internet and try again, or request a new QR Code",
          },
          qrcode: {
            title: "Waiting for QR Code read",
            content:
              "Click on 'QR CODE' button and read the QR Code with your cell phone to start session",
          },
          connected: {
            title: "Connection established",
          },
          hybridConnected: {
            content:
              "Web active: receives messages and sends media. Pair USB for text sending via phone.",
          },
          webOnlyConnected: {
            content:
              "Web-only mode: receives and sends everything via Web session (ideal for iPhone).",
          },
          timeout: {
            title: "Connection with cell phone has been lost",
            content:
              "Make sure your cell phone is connected to the internet and WhatsApp is open, or click on 'Disconnect' button to get a new QRcode",
          },
          waitingAgent: {
            title: "Waiting for Android agent",
            content: "Start android-bridge-agent on your PC and connect the phone via USB.",
          },
          deviceConnected: {
            title: "Android device connected",
            content: "Active session via USB bridge.",
          },
          deviceOffline: {
            title: "Device offline",
            content: "Local agent disconnected. Check USB, adb and agent process.",
          },
        },
        table: {
          name: "Name",
          whatsappId: "WhatsApp ID",
          whatsappIdHint:
            "Click the ID to copy. Use in MacroDroid JSON: \"whatsappId\": NUMBER",
          copyWhatsappId: "Copy WhatsApp ID",
          status: "Status",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
          connectionMode: "Mode",
          phone: "Phone",
          counterPhone: "Counter number",
          autoDisableCounter: "Auto deactivation",
        },
        autoDisable: {
          active: "Active",
        },
        connectionMode: {
          hybrid: "Hybrid",
          web: "Web only",
        },
        meta: {
          panelTitle: "Official WhatsApp (Meta Cloud)",
          panelInstructions:
            "Connect new numbers with Meta Embedded Signup. No Baileys QR Code.",
          connectButton: "Connect WhatsApp (Meta)",
          reconnectButton: "Reconnect Meta",
          connecting: "Connecting to Meta…",
          cloudLabel: "Meta Cloud",
          coexistenceHint:
            "Coexistence: after signup, open the WhatsApp Business app on the phone to finish sync.",
          signupTitle: "WhatsApp Embedded Signup",
          signupInstructions:
            "Log in to Meta and select or register the WhatsApp Business number. The token is saved on this connection.",
          promptLinked: "Connection prompt updated",
          sdrPrompt: "Attendance prompt",
          sdrPromptFallback: "Global fallback",
          promptsHint:
            "Upsell and aftercare: assign under Settings → AI prompts.",
        },
        bridge: {
          title: "Android Bridge (USB)",
          hybridTitle: "Hybrid mode (Web + USB)",
          agentOnline: "Local agent online",
          agentOffline: "Local agent offline",
          instructions:
            "Receive messages via WhatsApp Web (QR Code). Send text via USB when the agent is online; media always via Web. No MacroDroid.",
          hybridInstructions:
            "1) Open QR Code and scan on the phone. 2) In the same modal, select the USB device that scanned the QR and click Pair device.",
          pairSectionTitle: "Link USB phone",
          pairHint:
            "Choose the USB-connected device that scanned this QR Code on this instance.",
          selectDevice: "USB phone",
          noDevices: "No phone detected on the local agent.",
          agentRequired:
            "Start the Bridge agent on your PC with the phone connected via USB.",
          alreadyPaired: "Device linked:",
          keepAwakeTitle: "Keep screen on",
          keepAwakeMinutes: "Min",
          keepAwakeSave: "Save",
          keepAwakeSaved: "Screen timer saved.",
          keepAwakeInvalid: "Enter valid minutes (0 disables).",
          keepAwakeActive: "Action every {{minutes}} min on USB device.",
          keepAwakeOff: "Off (0 = no action).",
          escrcpyHint: "Mirror screen: scrcpy -s DEVICE_SERIAL (or Escrcpy on PC).",
          pairDevice: "Pair device",
          paired: "Device paired successfully!",
        },
      },
      whatsappModal: {
        title: {
          add: "Add WhatsApp",
          edit: "Edit WhatsApp",
        },
        form: {
          name: "Name",
          default: "Default",
          counterPhone: "Counter number",
          autoDisableCounter: "Automatic deactivation",
          connectionMode: "Connection mode",
          connectionModeHybrid: "Hybrid (Web receives + USB sends text)",
          connectionModeWeb: "Web only (iPhone / no USB)",
          connectionModeHybridHint:
            "Receives messages via Web and sends text via Android phone over USB.",
          connectionModeWebHint:
            "Receives and sends everything via Web session. Use for iPhone or when USB does not work.",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "WhatsApp saved successfully.",
      },
      qrCode: {
        message: "Read QrCode to start the session",
        scanDone: "QR Code scanned! Now link the USB phone.",
        webActive: "Web session active. Link the USB device below.",
        waiting: "Waiting for QR Code...",
      },
      contacts: {
        title: "Contacts",
        toasts: {
          deleted: "Contact deleted sucessfully!",
        },
        searchPlaceholder: "Search ...",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitlte: "Import contacts",
          deleteMessage:
            "Are you sure you want to delete this contact? All related tickets will be lost.",
          importMessage: "Do you want to import all contacts from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          add: "Add Contact",
        },
        table: {
          name: "Name",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
        },
        paidBadge: "(PAID)",
      },
      contactModal: {
        title: {
          add: "Add contact",
          edit: "Edit contact",
        },
        form: {
          mainInfo: "Contact details",
          extraInfo: "Additional information",
          name: "Name",
          number: "Whatsapp number",
          email: "Email",
          extraName: "Field name",
          extraValue: "Value",
        },
        buttons: {
          addExtraInfo: "Add information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
      },
      quickAnswersModal: {
        title: {
          add: "Add Quick Reply",
          edit: "Edit Quick Answer",
        },
        form: {
          shortcut: "Shortcut",
          message: "Quick Reply",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Quick Reply saved successfully.",
      },
      queueModal: {
        title: {
          add: "Add queue",
          edit: "Edit queue",
        },
        form: {
          name: "Name",
          color: "Color",
          greetingMessage: "Greeting Message",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
      },
      userModal: {
        title: {
          add: "Add user",
          edit: "Edit user",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          profile: "Profile",
          whatsapp: "Default Connection",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "User saved successfully.",
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "New",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Queues",
      },
      ticketsWhatsappSelect: {
        placeholder: "Numbers",
      },
      tickets: {
        toasts: {
          deleted: "The ticket you were on has been deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolved" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search tickets and messages.",
        },
        buttons: {
          showAll: "All",
        },
        responseWindow: {
          open: "Window: {{time}}",
          openTip:
            "Meta 24h window: starts from the customer's last message. Free replies while open.",
          closed: "Window: closed",
          closedTip:
            "24h window closed. Use an approved template or wait for the customer to message again.",
          noCustomerMessage: "Window: waiting for customer",
          noCustomerMessageTip:
            "No customer message on this ticket yet. The 24h window starts when they send one.",
        },
      },
      transferTicketModal: {
        title: "Transfer Ticket",
        fieldLabel: "Type to search for users",
        fieldQueueLabel: "Transfer to queue",
        fieldConnectionLabel: "Transfer to connection",
        fieldQueuePlaceholder: "Please select a queue",
        fieldConnectionPlaceholder: "Please select a connection",
        noOptions: "No user found with this name",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      ticketsList: {
        pendingHeader: "Queue",
        assignedHeader: "Working on",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage: "No tickets found with this status or search term.",
        connectionTitle: "Connection that is currently being used.",
        buttons: {
          accept: "Accept",
        },
      },
      newTicketModal: {
        title: "Create Ticket",
        fieldLabel: "Type to search for a contact",
        add: "Add",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Connections",
          waba: "WABA",
          meta: "META",
          tickets: "Tickets",
          contacts: "Contacts",
          quickAnswers: "Quick Answers",
          chatFlows: "Flows",
          pixel: "Pixel",
          campanhas: "Tracking",
          webhook: "Webhook",
          counterNumbers: "Numbers",
          leadMessages: "Message Log",
          queues: "Queues",
          administration: "Administration",
          users: "Users",
          settings: "Settings",
          proxy: "Proxy",
        },
        appBar: {
          autoAttend: "Auto attend with AI",
          autoAttendSelectNumbers: "Choose numbers for auto AI",
          autoAttendConfirm: "Enable",
          autoAttendCancel: "Cancel",
          disableAllAi: "Turn off AI on all tickets",
          disableAllAiConfirm:
            "Turn off AI on ALL tickets now? (support, upsell and aftercare)",
          disableAllAiDone: "AI disabled on {{count}} ticket(s).",
          translation: "Real-time translation (turn off to save API usage)",
          translationNeedsKey:
            "Set Google Translation API key in Settings to enable",
          translationEnabled: "Auto translation",
          agentLanguage: "Main language (panel)",
          outputLanguage: "Output language (sent messages)",
          translationPrivacyNote:
            "Primary: LibreTranslate on the VPS. Google is standby if Libre fails.",
          translationLibreUrl: "LibreTranslate URL",
          translationLibreHelp: "E.g. http://127.0.0.1:5000 (localhost on the VPS)",
          translationSaveLibre: "Save Libre URL",
          translationLibreSaved: "LibreTranslate URL saved",
          translationLibreConfigured: "LibreTranslate configured (primary)",
          translationLibreMissing: "No Libre URL — use Google standby or configure",
          translationApiKey: "Google standby (API key)",
          translationApiKeyHelp:
            "Used only if LibreTranslate fails. Can stay empty if Libre is stable.",
          translationSaveApiKey: "Save Google standby",
          translationKeySaved: "Google key saved",
          translationKeyConfigured: "Google standby configured",
          translationUsesGemini: "Using Gemini key from AI settings",
          translationKeyMissing: "No Google standby",
          translationApiKeyEmpty: "Paste the key before saving",
          translationApiKeyReplace: "Paste a new key to replace",
          user: {
            profile: "Profile",
            logout: "Logout",
          },
        },
      },
      notifications: {
        noTickets: "No notifications.",
      },
      queues: {
        title: "Queues",
        table: {
          name: "Name",
          color: "Color",
          greeting: "Greeting message",
          actions: "Actions",
        },
        buttons: {
          add: "Add queue",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? It cannot be reverted! Tickets in this queue will still exist, but will not have any queues assigned.",
        },
      },
      queueSelect: {
        inputLabel: "Queues",
      },
      quickAnswers: {
        title: "Quick Answers",
        table: {
          shortcut: "Shortcut",
          message: "Quick Reply",
          actions: "Actions",
        },
        buttons: {
          add: "Add Quick Reply",
        },
        toasts: {
          deleted: "Quick Reply deleted successfully.",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Quick Reply: ",
          deleteMessage: "This action cannot be undone.",
        },
      },
      chatFlows: {
        title: "Flows",
        hint:
          "Visual chatbot builder: drag nodes, connect edges, activate. Runs on unassigned tickets (Meta Cloud).",
        noFlows: "No flows yet.",
        table: {
          name: "Name",
          keyword: "Trigger",
          triggers: "Triggers",
          manualOnly: "Manual only",
          active: "Active",
          actions: "Actions",
        },
        buttons: {
          add: "New flow",
          save: "Save",
          cancel: "Cancel",
          openEditor: "Open editor",
        },
        form: {
          name: "Flow name",
          message: "Text message",
          active: "Active",
          keyword: "Keyword",
          graph: "JSON graph (nodes/edges)",
        },
        modal: {
          create: "Create flow",
          edit: "Edit flow",
        },
        toasts: {
          created: "Flow created.",
          updated: "Flow updated.",
          deleted: "Flow deleted.",
        },
        nodes: {
          start: "Start",
          message: "Message",
          audio: "Audio",
          video: "Video",
          button: "Buttons",
          list: "List",
          input: "Input",
          wait_reply: "Wait for reply",
          condition: "Condition",
          delay: "Delay",
          api_call: "API Call",
          ai_reply: "AI Reply",
          loop: "Loop",
          subflow: "Subflow",
          end: "End",
        },
        editor: {
          title: "Flow editor",
          tabFlow: "Flow",
          tabTriggers: "Triggers",
          palette: "Library",
          paletteHint: "Drag nodes onto the canvas (Message, Audio, Video…)",
          config: "Settings",
          selectNode: "Select a node to edit.",
          label: "Label",
          text: "Text",
          prompt: "Prompt",
          waitPrompt: "Optional message (before waiting)",
          waitPromptHint: "Leave empty to pause until the next customer message.",
          variableName: "Save to variable",
          mediaType: "Content type",
          mediaText: "Text",
          mediaImage: "Image",
          mediaVideo: "Video",
          mediaAudio: "Audio",
          caption: "Caption (optional)",
          mediaUrl: "Media URL",
          mediaUrlHint: "Public URL or use upload below",
          audioHint: "Record in the browser or upload ogg/mp3/m4a/webm. Sent as a WhatsApp voice note.",
          videoHint: "Prefer MP4 (H.264). Suggested max size: 64 MB.",
          imageHint: "JPG, PNG or WEBP.",
          asVoiceNote: "Send as voice note",
          fileTooLarge: "File too large (max {{max}} MB).",
          upload: "Upload file",
          record: "Record",
          stopRecord: "Stop",
          clearMedia: "Clear media",
          buttons: "Buttons",
          buttonLabel: "Label",
          addButton: "Add button",
          buttonMode: "Button type",
          buttonModeReply: "Reply",
          buttonModeCta: "Action / CTA (link)",
          buttonModeReplyHint:
            "Up to 3 reply buttons. The flow pauses and continues on the clicked button edge.",
          buttonModeCtaHint:
            "One Meta CTA URL button. After sending, the flow advances automatically (click opens the browser and does not hit the webhook).",
          ctaSection: "Action button (CTA URL)",
          ctaContinueHint:
            "Connect the default output to the next node. To wait for a message after the CTA, use a “Wait for reply” node.",
          ctaCatalog: "Saved CTA (catalog)",
          ctaCatalogManual: "Fill in manually",
          ctaCatalogHint: "Optional: pick a saved CTA to prefill the fields below.",
          ctaBody: "Message text",
          ctaDisplayText: "Button label",
          ctaUrl: "URL (https)",
          ctaUrlHint: "Required: URL starting with https://",
          ctaHeader: "Header (optional)",
          ctaFooter: "Footer (optional)",
          listButton: "List button text",
          addRow: "Add row",
          leftOperand: "Left operand",
          operator: "Operator",
          rightOperand: "Right operand",
          seconds: "Seconds",
          handoff: "End and hand off to human/AI",
          deleteNode: "Delete node",
          nameRequired: "Enter a name with at least 2 characters.",
        },
        triggers: {
          title: "Funnel triggers",
          hint:
            "When this flow starts on open/unassigned tickets if there is no active session.",
          mode: "Start mode",
          anyMessage: "Any message (any_message)",
          contains: "Message contains (keyword)",
          exact: "Exact message (exact)",
          modeHelp: "Specific matches take priority over “any message”.",
          phrases: "Trigger phrases",
          phrasePlaceholder: "e.g. hi, quote, menu",
          addPhrase: "Add",
          phrasesRequired: "Add at least one trigger phrase.",
          whatsapp: "WhatsApp connection",
          anyWhatsapp: "All connections",
          whatsappHelp: "Optional: limit the funnel to one connection.",
          enabled: "Automatic triggers",
          enabledHelp:
            "Off: this flow starts only when an agent clicks it on the ticket. On: it also starts from the rules below (any_message, keyword or exact).",
          oncePerChat: "Trigger only once per chat",
          oncePerChatHelp:
            "On: the automatic trigger (any_message, keyword or exact) will not restart this flow on the same ticket after the first run. Off: it fires again on every message when there is no active session. Manual start by an agent ignores this setting.",
          priorityNote:
            "Priority: specific match (exact/keyword) before any_message; among multiple any, lowest id wins (connection-scoped first).",
        },
      },
      users: {
        title: "Users",
        table: {
          name: "Name",
          email: "Email",
          profile: "Profile",
          whatsapp: "Default Connection",
          actions: "Actions",
        },
        buttons: {
          add: "Add user",
        },
        toasts: {
          deleted: "User deleted sucessfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All user data will be lost. Users' open tickets will be moved to queue.",
        },
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        settings: {
          userCreation: {
            name: "User creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          aiAssistant: {
            title: "AI Assistant",
            privacyNote:
              "Conversations are sent to the configured AI provider (Gemini, Anthropic, or Qwen). Configure the keys below.",
            provider: "Active provider",
            geminiSection: "Google Gemini",
            anthropicSection: "Anthropic (Claude Sonnet)",
            qwenSection: "QwenCloud (Qwen 3.7 Plus)",
            model: "Gemini model",
            anthropicModel: "Claude model",
            qwenModel: "Qwen model",
            apiKey: "Gemini API Key",
            anthropicApiKey: "Anthropic API Key",
            qwenApiKey: "Qwen / DashScope API Key",
            saveApiKey: "Save Gemini key",
            saveAnthropicApiKey: "Save Anthropic key",
            saveQwenApiKey: "Save Qwen key",
            postSalePromptTitle: "Upsell / post-payment (global fallback)",
            postSalePromptHelp:
              "Used after the 1st payment if the connection has no upsell prompt linked. Not the support aftercare prompt.",
            prompt: "Upsell / post-payment prompt",
            promptHelp:
              "Placeholders: {nome}, {telefone}, {valor_venda}, {utm_campaign}",
            savePrompt: "Save upsell / post-payment prompt",
            atendimentoPromptTitle: "Attendance (global fallback)",
            atendimentoPromptHelp:
              "Used only when the connection has no attendance prompt linked above.",
            atendimentoPrompt: "Attendance prompt (fallback)",
            saveAtendimentoPrompt: "Save attendance prompt",
            aftercarePromptTitle: "Aftercare / support (global fallback)",
            aftercarePromptHelp:
              "Used after the 2nd payment if the connection has no aftercare prompt linked. Calm, support, handle complaints — not upsell.",
            aftercarePrompt: "Aftercare (support) prompt",
            saveAftercarePrompt: "Save aftercare prompt",
            autoAttendNewContactsOnly: "AI auto-attend for new contacts only",
            autoAttendNewContactsOnlyHelp:
              "When enabled, automatic AI attendance only starts for contacts who have never received a human reply. Returning contacts wait for human agents.",
            autoAttendNewContactsOnlyOptions: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
            maxReplies: "Max replies per hour (per ticket)",
            historyMessages: "History messages in context (recommended: 40+)",
            replyDelayMin: "Minimum delay (seconds)",
            replyDelayMax: "Maximum delay (seconds)",
            replyDelayHelp:
              "AI waits a random time between min and max before replying. If max is 0 or equals min, uses fixed min delay.",
          },
          aiPromptsSection: {
            title: "AI prompts",
            help:
              "1) Create prompts in the library · 2) Assign per connection (attendance, upsell, aftercare) · 3) Global fallbacks apply only when the connection has none.",
          },
          aiPrompts: {
            title: "1. Prompt library",
            help:
              "Create and edit saved prompts. Choose the mode (attendance, upsell or aftercare), then assign in the next section.",
            name: "Prompt name",
            mode: "Mode",
            modeHelp:
              "Which flow this prompt serves: attendance, upsell (1st payment) or aftercare (2nd payment).",
            modes: {
              atendimento: "Attendance",
              postsale: "Upsell / post-payment",
              aftercare: "Aftercare (support)",
            },
            prompt: "Prompt text",
            active: "Active",
            connections: "Linked connections",
            actions: "Actions",
            add: "Add prompt",
            save: "Save changes",
            cancelEdit: "Cancel edit",
            created: "Prompt created",
            updated: "Prompt updated",
            deleted: "Prompt removed",
            confirmDelete:
              "Remove this prompt? Linked connections fall back to the global prompt.",
            required: "Fill in name and prompt text",
            empty: "No saved prompts yet",
            yes: "Yes",
            no: "No",
          },
          aiPromptAssign: {
            title: "2. Assignment per connection",
            help:
              "For each WhatsApp connection, pick attendance, upsell and aftercare prompts. Empty = use global fallback.",
            connection: "Connection",
            useGlobal: "Global fallback",
            saved: "Connection prompt updated",
            empty: "No WhatsApp connections found",
          },
          aiFallbacks: {
            title: "3. Global fallbacks",
            help:
              "Used only when the connection has no prompt for that mode. Existing installs keep working with these texts alone.",
          },
          ctaButtons: {
            sectionTitle: "Buttons",
            sectionHelp:
              "1) Create CTA buttons in the library · 2) Assign which buttons each WhatsApp connection can use. No links = all buttons (fallback).",
            libraryTitle: "1. Button library",
            libraryHelp:
              "Create and edit CTA URL buttons. AI uses [[CTA_BUTTON:Name]] and agents send them from chat.",
            assignTitle: "2. Assignment per connection",
            assignHelp:
              "For each number/connection, pick allowed buttons. Empty selection = all global buttons.",
            linkedButtons: "Buttons",
            useAllButtons: "All buttons (fallback)",
            assignSaved: "Connection buttons updated",
          },
          translation: {
            title: "Real-time translation",
            privacyNote:
              "Uses Google Cloud Translation API. Enable the API in Google Cloud Console (separate from Gemini).",
            enabled: "Translation enabled",
            agentLanguage: "Agent language (read/write in panel)",
            apiKey: "Google Translation API key",
            apiKeyHelp:
              "You can use the same Google account as Gemini, but Cloud Translation API must be enabled.",
            saveApiKey: "Save translation key",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
        },
      },
      messagesList: {
        aiBadge: "AI",
        translationLabel: "Translation",
        sentTranslationLabel: "Sent",
        translateButton: "Translate",
        translating: "Translating...",
        ctaUrl: {
          open: "Open link",
        },
        header: {
          assignedTo: "Assigned to:",
          aiActive: "AI active",
          aiModeSdr: "Attendance",
          aiModePostSale: "Upsell / Post-payment",
          aiModePostSaleShort: "Upsell",
          aiModeAftercare: "Aftercare (support)",
          aiModeAftercareShort: "Aftercare",
          aiDisable: "Turn off AI",
          buttons: {
            return: "Return",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
            pixel: "Pixel",
            ai: "AI",
            aiOn: "AI on",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Type a message or press ''/'' to use the registered quick responses",
        placeholderClosed: "Reopen or accept this ticket to send a message.",
        signMessage: "Sign",
        translationPreview: "Will be sent in {{language}}: {{text}}",
        translationAgentPreview: "Translation to {{language}}: {{text}}",
        chatFlows: {
          label: "Chat flows",
          starting: "Starting…",
          started: "Flow \"{{name}}\" started.",
          confirmTitle: "Start flow",
          confirmMessage:
            "Start flow \"{{name}}\" on this ticket? Any previous active session will be replaced.",
          statusRunning: "In progress",
          statusWaiting: "Waiting for reply",
          statusCompleted: "Flow completed",
          statusHandedOff: "Handed off to agent",
          statusError: "Flow error",
          statusCancelled: "Flow cancelled",
        },
        ctaUrl: {
          title: "Call-to-action link button",
          listTitle: "Saved CTA link buttons",
          createTitle: "Create CTA link button",
          editTitle: "Edit CTA link button",
          name: "Name (optional)",
          header: "Header (optional)",
          body: "Message text",
          displayText: "Button label",
          url: "URL (https)",
          footer: "Footer (optional)",
          send: "Send",
          save: "Save",
          saveAndSend: "Save and send",
          cancel: "Cancel",
          createNew: "Create new button",
          edit: "Edit",
          delete: "Delete",
          emptyList: "No saved buttons yet. Create the first one.",
          clickToSend: "Click to send",
          sending: "Sending...",
          success: "CTA link button sent",
          saved: "Button saved",
          updated: "Button updated",
          deleted: "Button deleted",
          deleteConfirm: "Delete button \"{{name}}\"?",
          errors: {
            bodyRequired: "Message text is required",
            displayTextRequired: "Button label is required",
            invalidUrl: "Enter a valid URL starting with https://",
          },
        },
      },
      contactDrawer: {
        header: "Contact details",
        buttons: {
          edit: "Edit contact",
        },
        customerLanguage: "Customer language",
        customerLanguageAuto: "Detect automatically",
        pixelCreative: "Ad",
        pixelAdId: "AD ID",
        extraInfo: "Other information",
      },
      ticketOptionsMenu: {
        delete: "Delete",
        transfer: "Transfer",
        confirmationModal: {
          title: "Delete ticket #",
          titleFrom: "from contact ",
          message: "Attention! All ticket's related messages will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      messageOptionsMenu: {
        delete: "Delete",
        reply: "Reply",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be reverted.",
        },
      },
      metaOnboarding: {
        introTitle: "Meta WhatsApp App Review checklist",
        introBody:
          "Validate what already exists in Oficial and mark manual App Review proofs. Green badges mean the feature exists in the product — not Meta Advanced Access approval.",
        proofProgress: "Manual proofs marked: {{done}}/{{total}}",
        howToRecord: "How to record for App Review",
        markDone: "I marked this proof / step as done",
        privacyPolicyUrl: "Privacy Policy URL",
        termsUrl: "Terms of Use URL",
        policyHelper:
          "Paste the public URL and set the same in Meta App Dashboard → Settings → Basic.",
        termsHelper:
          "Optional in-product; Meta requires a public privacy policy. Terms help review.",
        savePolicyUrls: "Save URLs to Settings",
        openPrivacy: "Open privacy",
        openTerms: "Open terms",
        status: {
          available: "Available in system",
          configure: "Configure",
          external: "External action (Meta)",
          manual: "Manual App Review",
        },
        sections: {
          messaging: "whatsapp_business_messaging",
          management: "whatsapp_business_management",
          prerequisites: "Prerequisites",
        },
        links: {
          tickets: "Conversations / Tickets",
          inbox: "Inbox",
          webhook: "Webhook (panel)",
          waba: "WABA panel",
          wabaWebhooks: "WABA → Webhooks",
          wabaTemplates: "WABA → Templates",
          wabaSync: "WABA → Sync",
          embeddedSignup: "Embedded Signup",
          connections: "Connections",
          settings: "Settings",
          metaTemplates: "Templates in Business Manager",
          coexistenceDocs: "Meta docs: Coexistence",
          metaDevelopers: "Meta for Developers",
          metaPrivacy: "Privacy requirements",
          metaAppDashboard: "Meta App Dashboard",
          appReviewDocs: "App Review docs",
        },
        items: {
          msgSend: {
            title: "Send message to customer",
            desc:
              "Conversations panel (/tickets) sends text/media via Meta Cloud API.",
            tip:
              "Record: open ticket → type message → send → message shows with check. Show official Meta Cloud number.",
          },
          msgReceive: {
            title: "Receive customer messages in Inbox",
            desc:
              "Active Meta webhook; messages land in Tickets in real time.",
            tip:
              "Record: customer sends on WhatsApp → ticket updates in Inbox. Also show WABA → Webhooks or /webhook.",
          },
          msgAck: {
            title: "Delivery/read status (ACK)",
            desc:
              "Status webhooks update ticks (sent/delivered/read) in the message list.",
            tip:
              "Send a message and show ACK icons evolving (clock → 1 check → 2 checks → blue).",
          },
          msgProof: {
            title: "Usage proof (messaging) for App Review",
            desc:
              "Video + description of the functional send/receive flow for this permission.",
            tip:
              "One continuous video: Meta Connections → Tickets → send → receive → ACK. Describe the use case in the Meta form.",
          },
          mgmtConnect: {
            title: "Connect WABA and official number",
            desc:
              "Embedded Signup at /waba-signup and management in Connections / WABA.",
            tip:
              "Record Embedded Signup until the number appears in Connections as Meta Cloud.",
          },
          mgmtTemplates: {
            title: "Create/edit templates",
            desc:
              "List/sync in WABA panel; advanced creation in Meta Business Manager.",
            tip:
              "Show templates listed in WABA and, if creating/editing, the BM flow. Be honest: full creation is on Meta.",
          },
          mgmtSync: {
            title: "Sync templates and WABA account",
            desc: "«Sync admin» button and overview tabs on /waba.",
            tip:
              "Record: WABA → Sync admin → numbers/templates/webhooks refreshed.",
          },
          mgmtWebhook: {
            title: "Webhook subscription and test event",
            desc:
              "subscribed_apps resubscribe in WABA + /webhook endpoint in panel.",
            tip:
              "Show webhook URL, resubscribe, and a real event (message or status) arriving.",
          },
          mgmtProof: {
            title: "Usage proof (management) for App Review",
            desc:
              "Management video: connect, sync, templates/webhooks as actually used.",
            tip:
              "Separate video from messaging: Embedded Signup → WABA sync → templates/webhooks.",
          },
          mgmtCoexistence: {
            title: "Coexistence with WhatsApp Business app",
            desc:
              "coexistence flag in Embedded Signup; final enablement is a Meta account feature + phone app.",
            tip:
              "Document: featureType whatsapp_business_app_onboarding + open WhatsApp Business on the phone after signup. Do not fake Advanced Access — Meta/account setup.",
          },
          preDevAccount: {
            title: "Active Meta Developer account",
            desc: "App on developers.facebook.com with WhatsApp products.",
            tip: "Show App Dashboard (no secrets) and WhatsApp products added.",
          },
          prePrivacy: {
            title: "Public privacy policy and terms",
            desc:
              "Public URLs in App Dashboard; optionally saved here (privacyPolicyUrl / termsUrl).",
            tip:
              "Record the public privacy page and the field in Meta App Settings → Basic.",
          },
          preBusiness: {
            title: "Business info / aligned use cases",
            desc:
              "Business Verification and usage description consistent with the product.",
            tip:
              "In App Review, describe official WhatsApp omnichannel support — aligned with Whaticket.",
          },
          preVideos: {
            title: "Separate video + description per permission",
            desc:
              "Meta requires distinct screencast and text for messaging and management.",
            tip:
              "Do not reuse the same video for both permissions. Check the boxes after recording each.",
          },
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "There must be at lest one default WhatsApp connection.",
        ERR_NO_DEF_WAPP_FOUND:
          "No default WhatsApp found. Check connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session is not initialized. Check connections page.",
        ERR_WAPP_CHECK_CONTACT:
          "Could not check WhatsApp contact. Check connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Could not download media from WhatsApp. Check connections page.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_SENDING_WAPP_MSG:
          "Error sending WhatsApp message. Check connections page.",
        ERR_WAPP_DISPLAY_NAME:
          "Meta blocked sending: this number’s display name is not approved yet in WhatsApp Manager.",
        ERR_WAPP_PAYMENT:
          "Meta blocked sending: there is a payment method error on the WhatsApp Business account.",
        ERR_WAPP_TOKEN:
          "Meta authentication failed. Update the WhatsApp connection token.",
        ERR_WAPP_UNDELIVERABLE:
          "Meta could not deliver the message to this number.",
        ERR_CTA_URL_META_ONLY:
          "CTA link buttons are only available with the official Meta Cloud API.",
        ERR_CTA_URL_BODY_REQUIRED: "CTA message text is required.",
        ERR_CTA_URL_BODY_TOO_LONG: "CTA message text exceeds 1024 characters.",
        ERR_CTA_URL_DISPLAY_TEXT_REQUIRED: "CTA button label is required.",
        ERR_CTA_URL_DISPLAY_TEXT_TOO_LONG:
          "CTA button label exceeds 20 characters.",
        ERR_CTA_URL_INVALID_URL:
          "Invalid CTA URL. Use an https:// address.",
        ERR_CTA_URL_HEADER_TOO_LONG: "CTA header exceeds 60 characters.",
        ERR_CTA_URL_FOOTER_TOO_LONG: "CTA footer exceeds 60 characters.",
        ERR_TRANSLATION_FAILED:
          "Could not translate the message. Check the key and Cloud Translation API in Google Cloud.",
        ERR_TRANSLATION_API_BLOCKED:
          "Cloud Translation API is blocked. Enable it at console.cloud.google.com/apis/library/translate.googleapis.com and check key restrictions.",
        ERR_TRANSLATION_INVALID_KEY:
          "Invalid Google Translation key. Generate a new key in Google Cloud Console.",
        ERR_TRANSLATION_KEY_TEST_FAILED:
          "Could not validate the Google Translation key. Try again.",
        ERR_TRANSLATION_API_KEY_EMPTY: "Enter the Google Translation key.",
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_OTHER_OPEN_TICKET:
          "There's already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please login.",
        ERR_USER_CREATION_DISABLED:
          "User creation was disabled by administrator.",
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_CREATING_MESSAGE: "Error while creating message on database.",
        ERR_CREATING_TICKET: "Error while creating ticket on database.",
        ERR_FETCH_WAPP_MSG:
          "Error fetching the message in WhtasApp, maybe it is too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "This color is already in use, pick another one.",
        ERR_WAPP_GREETING_REQUIRED:
          "Greeting message is required if there is more than one queue.",
        ERR_PIXEL_INVALID_VALUE: "Enter a valid sale value.",
        ERR_PIXEL_LEAD_NOT_FOUND: "Pixel lead not found for this contact.",
        ERR_PIXEL_ALREADY_CONVERTED: "This conversion was already sent to the pixel.",
        ERR_PIXEL_PHONE_NOT_FOUND: "Contact phone not found.",
        ERR_PIXEL_SEND_FAILED: "Failed to send conversion to the pixel.",
        ERR_COUNTER_NUMBERS_LIST: "Failed to list counter numbers.",
        ERR_COUNTER_NUMBER_ADD: "Failed to add number.",
        ERR_COUNTER_NUMBER_TOGGLE: "Failed to toggle number status.",
        ERR_COUNTER_NUMBER_UPDATE: "Failed to update number.",
        ERR_COUNTER_NUMBER_DELETE: "Failed to delete number.",
        ERR_LEAD_MESSAGES_LIST: "Failed to load recent messages.",
        ERR_NO_CHAT_FLOW_FOUND: "Chat flow not found.",
        ERR_CHAT_FLOW_NOT_FOUND: "Chat flow not found.",
        ERR_CHAT_FLOW_INACTIVE: "This chat flow is inactive.",
        ERR_CHAT_FLOW_WHATSAPP_MISMATCH:
          "This flow does not belong to this ticket's WhatsApp connection.",
        ERR_CHAT_FLOW_NO_START:
          "This flow has no valid start node. Open the editor and save the flow again.",
        ERR_CHAT_FLOW_START_FAILED:
          "Could not start the flow on this ticket. Please try again.",
      },
      leadMessages: {
        title: "Message Log",
        section: {
          title: "Latest Received Messages",
          subtitle:
            "Recent leads — message, destination WPP number, campaign and status",
        },
        stats: {
          total: "Total leads",
          today: "Leads today",
          converted: "Converted",
        },
        table: {
          date: "Date/Time",
          message: "Message",
          destination: "Destination WPP",
          campaign: "Campaign",
          status: "Status",
        },
        status: {
          pending: "Pending",
          converted: "Sold · €{{value}}",
        },
        empty: "No messages received yet.",
      },
      proxy: {
        title: "WhatsApp Proxy",
        formatHint:
          "Paste as host:port:username:password — default type HTTP (optional: socks5 or socks4 at the end)",
        status: {
          enabled: "Proxy enabled",
          disabled: "Proxy disabled",
        },
        source: {
          settings: "Source: panel",
          env: "Source: .env",
          none: "No proxy configured",
        },
        fields: {
          enabled: "Use proxy for WhatsApp",
          rawLine: "Full proxy string",
          parsedTitle: "Automatically recognized fields",
          host: "Host",
          port: "Port",
          username: "Username",
          password: "Password",
          passwordKeep: "Leave blank to keep current password",
          type: "Type",
        },
        buttons: {
          save: "Save proxy",
          check: "Test proxy",
          reload: "Reload",
        },
        check: {
          ok: "Proxy is working",
          fail: "Proxy test failed",
          latency: "Latency: {{ms}} ms",
          ip: "External IP: {{ip}}",
        },
        toasts: {
          saved: "Proxy saved successfully!",
          checkOk: "Proxy tested successfully!",
          checkFail: "Proxy did not respond",
        },
        note:
          "After changing the proxy, disconnect and reconnect the WhatsApp session in Connections to apply the change.",
      },
      counterNumbers: {
        title: "Counter Numbers",
        stats: {
          daily: "Daily clicks",
          total: "Total clicks",
          active: "Active channels",
        },
        form: {
          addTitle: "Add new channel",
          name: "Name",
          namePlaceholder: "e.g. Main WPP",
          phone: "Phone",
          message: "Default message (optional)",
          add: "Add",
          save: "Save",
          cancel: "Cancel",
          phoneRequired: "Phone is required.",
        },
        table: {
          active: "Active",
          name: "Channel",
          daily: "Clicks (day)",
          total: "Clicks (total)",
          rotation: "Rotation",
          actions: "Actions",
        },
        rotation: {
          next: "Next",
          last: "Last",
          queued: "Queued",
          inactive: "Inactive",
        },
        edit: {
          title: "Edit channel",
        },
        confirmDelete: {
          title: "Remove number",
          message: "Are you sure? The number will be removed from the click counter.",
        },
        toasts: {
          added: "Number added successfully!",
          updated: "Number updated!",
          deleted: "Number removed!",
        },
      },
      webhookPage: {
        title: "Stripe Webhook",
        endpoint1Title: "Endpoint 1 (primary Stripe)",
        endpoint2Title: "Endpoint 2 (second Stripe)",
        urlLabel: "Webhook URL (paste in Stripe Dashboard)",
        copy: "Copy",
        copied: "URL copied!",
        copyFail: "Could not copy.",
        refresh: "Refresh",
        secretLabel: "Signing secret (whsec_...)",
        secretPlaceholder: "whsec_••••••••",
        secretSave: "Save secret",
        secretSaved: "Signing secret saved!",
        secretRequired: "Enter the signing secret.",
        secretInvalid: "Secret must start with whsec_.",
        secretHelp:
          "Paste the Signing secret from the Stripe Dashboard. Stored in the database (Settings) — no PM2 restart needed.",
        secretConfiguredHint:
          "Configured (••••{{last4}}). Enter a new value to replace it.",
        secretOk: "Signing secret configured",
        secretOkMasked: "Configured ••••{{last4}}",
        secretMissing: "Signing secret not configured",
        instructions:
          "In Stripe → Developers → Webhooks → Add endpoint.\nEndpoint 1: paste endpoint 1 URL in the primary Stripe account.\nEndpoint 2: paste endpoint 2 URL in the second Stripe account.\nSelect checkout.session.* and payment_intent.* events.\nThen copy each Signing secret (whsec_...) and save it in the matching field (admin).\nNo secret key (sk_) needed — the panel only verifies webhook signatures.\n\nHandled events:",
        logsTitle: "Latest Stripe calls",
        empty: "No events received yet.",
        table: {
          createdAt: "When",
          eventType: "Event",
          status: "Status",
          contact: "Contact",
          ticket: "Ticket",
          pixel: "Pixel",
          error: "Error",
        },
      },
      campanhasPage: {
        title: "Tracking",
        hint:
          "Register the WhatsApp message pattern + Meta IDs/UTMs. When a system Stripe button is sent, UTMs and client_reference_id are appended automatically. After payment (Stripe postback), the paid amount is sent to Meta as Purchase.",
        empty: "No tracking configured yet.",
        buttons: {
          add: "New tracking",
          save: "Save",
          cancel: "Cancel",
        },
        table: {
          name: "Name",
          pattern: "Message",
          mode: "Mode",
          metaIds: "Meta IDs",
          status: "Status",
          actions: "Actions",
        },
        modes: {
          contains: "Contains",
          exact: "Exact",
        },
        status: {
          on: "On",
          off: "Off",
        },
        modal: {
          create: "New tracking",
          edit: "Edit tracking",
        },
        form: {
          name: "Name",
          messagePattern: "Message pattern",
          messagePatternHelp:
            "Text the customer sends on WhatsApp (e.g. emoji or campaign phrase).",
          matchMode: "Match mode",
          enabled: "Enabled",
          campaignId: "campaign_id",
          adsetId: "adset_id",
          adId: "ad_id",
          pixelId: "Pixel ID",
          pixelIdHelp:
            "Meta Pixel ID that receives Purchases for this tracking. Only this value is used on send.",
          currency: "Currency (fallback)",
          currencyHelp:
            "Used only if Stripe postback has no currency. Sale value always comes from payment.",
          stripeLink: "Stripe Payment link",
          stripeLinkHelp:
            "Do not use — system Stripe buttons get UTMs on send.",
          defaultValue: "Default value",
        },
        confirmation: {
          deleteTitle: "Delete",
          deleteMessage: "This cannot be undone.",
        },
        toasts: {
          saved: "Tracking saved.",
          deleted: "Tracking removed.",
          required: "Name and message pattern are required.",
          pixelRequired: "Pixel ID is required on the tracking.",
          copied: "Stripe link copied.",
          noStripe: "Add a Stripe link on this tracking first.",
        },
      },
      pixel: {
        title: "Pixel",
        creative: "Creative",
        adLabel: "Ad",
        adId: "AD ID",
        trackingLabel: "Tracking",
        trackingMatched: "Tracking matched",
        trackingNotMatched: "No message tracking",
        adNotFound: "Ad not identified",
        campaignLabel: "Campaign",
        campaignNotFound: "Campaign not identified",
        search: "Search by message, phone or creative",
        loadMore: "Load more",
        stats: {
          total: "Checked",
          complete: "Complete",
          incomplete: "Incomplete",
          converted: "Converted",
        },
        table: {
          contact: "Contact",
          message: "Message",
          creative: "Creative",
          phone: "Phone",
          status: "Pixel Status",
          checkedAt: "Checked at",
        },
        status: {
          complete: "Complete",
          incomplete: "Incomplete",
          notFound: "Not found",
          convertedShort: "Converted",
          converted: "Converted · €{{value}}",
          purchasesSummary: "{{count}} purchase(s) · Total €{{value}}",
        },
        modal: {
          title: "Send conversion to Pixel",
          phone: "Phone (automatic)",
          value: "Sale value (€)",
          send: "Send to Pixel",
          sendUpsell: "Send upsell",
          cancel: "Cancel",
          refresh: "Check again",
          message: "Tracked message",
          lookupDate: "Click date",
          leadDate: "Click date",
          lastPurchase: "Last purchase sent",
          invalidValue: "Enter a valid value.",
          success: "Conversion sent to pixel successfully!",
          upsellSuccess: "Upsell sent to pixel successfully!",
          refreshed: "Pixel data updated.",
        },
        manual: {
          title: "Manual search",
          date: "Click date",
          message: "Exact message",
          messagePlaceholder: "Paste the message the customer sent on WhatsApp",
          search: "Search lead",
          phone: "Buyer phone",
          notFound: "No lead found for this message and date.",
          clear: "Clear",
          messageRequired: "Enter the message to search.",
          dateRequired: "Enter the click date.",
          phoneRequired: "Enter the buyer phone.",
        },
      },
    },
  },
};

export { messages };
